import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { mobile } from '~/techstyle-shared/react-components';

import FabricCard from '../FabricCard';

const Wrapper = styled.div`
  display: flex;
  > figure img {
    max-height: 260px;
  }
  > figure:last-of-type {
    margin-left: ${({ theme }) => theme.sizes.xl}px;
  }
  ${mobile`
    width: auto;
    flex-direction: column;
    > figure:last-of-type {
      margin-left: 0;
      margin-top: ${({ theme }) => theme.sizes.md}px;
    }
  `}
`;

export default function FabricCardsLayout({ fabrics, handleLearnMoreClick }) {
  const showCards = Object.keys(fabrics).map((fabric) => (
    <FabricCard
      key={fabric}
      fabricKey={fabrics[fabric].key}
      fabric={fabrics[fabric].fabricCard}
      handleLearnMore={() => handleLearnMoreClick(fabrics[fabric])}
    />
  ));

  return <Wrapper>{showCards}</Wrapper>;
}

FabricCardsLayout.propTypes = {
  fabrics: PropTypes.object,
  handleLearnMoreClick: PropTypes.func,
};
